export default "__VITE_ASSET__CFlx_GLr__"